import React from 'react'
import { NavLink } from 'react-router-dom'

export const SidebarButtonUnstyled = props => {
  return (
    <NavLink
      activeClassName="active"
      className={props.className}
      to={props.to || ''}
      id={props.id}
      isActive={props.isActive}
    >
      {props.children}
      <div className={'icon'}>{props.icon}</div>
    </NavLink>
  )
}



// WEBPACK FOOTER //
// ./src/Components/Sidebar/SidebarButton/unstyled.js